.emailWrapper {
  position: relative;

  .email {
    padding-top: 12px;
  }

  &_title {
    position: absolute;
    top: 11px;
    left: 24px;
    z-index: 5;
    color: #7B766F;
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: -0.3px;
  }
}

.error {
  border: 1px solid #f76060;
}

.email::placeholder {
  color: #AAA59F;
}

.emailWrapper.empty {

  .email {
    padding-top: 26.5px;
  }
}

// Dark mode
:global body.dark {
  :local {
    .error {
      color: #E44A08;
      border: 1px solid #E44A08;
      p {
        color: #E44A08;
      }
    }
  }
}

